import React, { useEffect, useRef, useState } from 'react';
import styles from './LandingHeader.module.scss';
import MiniLogo from 'components/Logo/MiniLogo';
import { useHistory, NavLink } from 'react-router-dom';
import { useWindowDimensions } from 'context/window';
import { PAGES } from 'routes/PAGES';
import { ReactComponent as MenuIcon } from "assets/Imgs/menu.svg";
import Button from 'components/Button/Button';
import { markTelegramManualLoginIntent } from 'services/telegramStartParam';

const LandingHeader = () => {
    const history = useHistory();
    const fixedNavBarRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const { width } = useWindowDimensions();

    useEffect(() => {
        const handleScroll = () => {
            const fixedNavBar = fixedNavBarRef.current;
            if (fixedNavBar) {
                if (window.scrollY > 78) {
                    fixedNavBar.style.boxShadow = "0px 4px 8px 0px rgba(61, 90, 128, 0.14)";
                } else {
                    fixedNavBar.style.boxShadow = "none";
                }
            }
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIsMenuOpen(width > 767);
    }, [width]);

    const toggleMenu = (e) => {
        if (e.target.tagName === 'NAV' && width < 768) {
            setIsMenuOpen(false);
        }
    };

    return (
        <header className={styles.landingHeader} ref={fixedNavBarRef}>
            <div className={styles.wrapper}>
                <NavLink
                    className={styles.logoLink}
                    to={PAGES.WELCOME}
                    onClick={() => {
                        gtag('event', 'header_logo_click')
                    }}>
                    <MiniLogo className={styles.logo} />
                </NavLink>
                <Button
                    onClick={() => setIsMenuOpen(true)}
                    style={styles.menu}
                    icon={<MenuIcon />}
                    iconOnly
                />
                {isMenuOpen && <nav onClick={toggleMenu}>
                    <div className={styles.sections}>
                        <section className={styles.navLinks}>
                            <ul>
                                <li>
                                    <NavLink to={PAGES.REGISTRATION} onClick={() => {
                                        gtag('event', 'header_about_click')
                                    }}>
                                        About
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={PAGES.REGISTRATION} onClick={() => {
                                        gtag('event', 'header_members_click')
                                    }}>
                                        Members
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={PAGES.REGISTRATION} onClick={() => {
                                        gtag('event', 'header_experts_click')
                                    }}>
                                        Experts
                                    </NavLink>
                                </li>
                            </ul>
                        </section>
                        <section className={styles.authLinks}>
                            <a
                                role='button'
                                className={styles.closeMenu}
                                onClick={() => {
                                    setIsMenuOpen(false);
                                }}>
                                Cancel
                            </a>
                            <NavLink to={PAGES.LOGIN} onClick={() => {
                                gtag('event', 'header_login_click')
                                markTelegramManualLoginIntent();
                            }}>
                                Log In
                            </NavLink>
                            <Button
                                style={styles.signUp}
                                to={PAGES.REGISTRATION}
                                onClick={() => {
                                    gtag('event', 'header_signup_click');
                                    history.push(PAGES.REGISTRATION);
                                }}
                            >
                                Sign Up
                            </Button>
                        </section>
                    </div>
                </nav>}
            </div>
        </header>
    );
};

export default LandingHeader;
